export default {
  machine: {
    EmptyName: {
      en: "Unnamed",
      pt: "Sem nome",
    },
  },
  clear: {
    title: {
      en: "Clear Old History",
      pt: "Limpar Histórico Antigo",
    },
    bulkDelete: {
      title: {
        en: "Confirm Bulk Deletion?",
        pt: "Confirmar Exclusão em Massa?",
      },
      alert: {
        success: {
          en: "Bulk deletion completed successfully!",
          pt: "Exclusão em massa realizada com sucesso!",
        },
        error: {
          en: "Error during bulk deletion. Please try again later.",
          pt: "Erro durante a exclusão em massa. Por favor, tente novamente mais tarde.",
        },
      },
    },
    description: {
      en: "This action will permanently delete all historical data older than the specified number of days. This operation cannot be undone. Are you sure you want to proceed?",
      pt: "Esta ação irá excluir permanentemente todos os dados históricos com mais de um determinado número de dias. Esta operação não pode ser desfeita. Tem certeza de que deseja continuar?",
    },
    inputLabel: {
      en: "Delete records older than:",
      pt: "Excluir registros com mais de:",
    },
    cancelButton: {
      en: "Cancel",
      pt: "Cancelar",
    },
    confirmButton: {
      en: "Confirm",
      pt: "Confirmar",
    },
    period: {
      days: {
        en: "days",
        pt: "dias",
      },
      month: {
        en: "month",
        pt: "mês",
      },
      months: {
        en: "months",
        pt: "meses",
      },
      year: {
        en: "year",
        pt: "ano",
      },
    },
    alert: {
      success: {
        en: "Item cleared successfully!",
        pt: "Item excluído com sucesso!",
      },
      error: {
        en: "Error clearing item. Please try again later.",
        pt: "Erro ao excluir o item. Por favor, tente novamente mais tarde.",
      },
    },
  },
};
